// Scroll-reveal directive: adds .is-visible when element enters viewport.
// Usage: v-reveal  or  v-reveal="{ delay: 150 }"
const observer = typeof IntersectionObserver !== 'undefined'
  ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    )
  : null

export const reveal = {
  mounted(el, binding) {
    el.classList.add('reveal')
    const delay = binding?.value?.delay
    if (delay) el.style.transitionDelay = `${delay}ms`
    if (observer) {
      observer.observe(el)
      // Safety net: reveal anything already in the viewport on mount, in case the
      // observer callback is delayed (e.g. above-the-fold hero content on first paint).
      const revealIfInView = () => {
        const r = el.getBoundingClientRect()
        const vh = window.innerHeight || document.documentElement.clientHeight
        if (r.top < vh * 0.98 && r.bottom > -40) {
          el.classList.add('is-visible')
          observer.unobserve(el)
        }
      }
      requestAnimationFrame(revealIfInView)
      // Absolute fallback so content is never stuck hidden if the observer never fires.
      setTimeout(() => el.classList.add('is-visible'), 700)
    } else {
      el.classList.add('is-visible')
    }
  },
  unmounted(el) {
    if (observer) observer.unobserve(el)
  }
}
